export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/shared/enums/CartItemType.ts